import React from 'react';
import SessionsPopover from '@src/components/pc/Claw/chat/SessionsPopover';
import './index.less';

/**
 * 侧边栏「历史」区：Mario Claw 路由下展示 Claw WS 会话列表（与 Header 里 SessionsPopover 同源数据）。
 */
export const ClawSidebarSessionList = () => {
  return (
    <div className="kim-ai-mario-claw-sidebar-session-list">
      <div className="kim-ai-mario-claw-sidebar-session-list__scroll">
        <SessionsPopover open embedInSidebar />
      </div>
    </div>
  );
};
